<template>
  <el-container>
    <Sider/>
    <el-main>
      <Header/>
      <el-tabs v-model="activeIndex" type="card" closable v-if="openTabs.length"
               @tab-click='tabClick'
               @tab-remove='tabRemove'>
        <el-tab-pane :key="item.name" v-for="item in openTabs" :label="item.name" :name="item.route">
        </el-tab-pane>
      </el-tabs>

      <div class="content">
        <!--        <router-view/>-->
        <keep-alive :include="catch_components">
          <router-view/>
        </keep-alive>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import Sider from './Sider'
import Header from './Header'

export default {
  components: {
    Sider,
    Header
  },
  data() {
    return {}
  },
  computed: {
    catch_components() {
      // keepalive缓存
      return this.$store.state.catch_components;
    },
    openTabs() {
      return this.$store.state.openTabs;
    },
    activeIndex: {
      get() {
        return this.$store.state.activeIndex;
      },
      set(val) {
        this.$store.commit('set_active_index', val);
      }
    }
  },
  methods: {
    //tab标签点击时，切换相应的路由
    tabClick() {
      this.$router.push({path: this.activeIndex});
    },
    //移除tab标签
    tabRemove(targetName) {
      //首页不删
      if (targetName === '/home') {
        return
      }
      this.$store.commit('delete_tabs', targetName);
      if (this.activeIndex === targetName) {
        // 设置当前激活的路由
        if (this.openTabs && this.openTabs.length >= 1) {
          this.$store.commit('set_active_index', this.openTabs[this.openTabs.length - 1].route);
          this.$router.push({path: this.activeIndex});
        } else {
          this.$router.push({path: '/'});
        }
      }
    },
  },
  watch: {
    '$route'(to) {
      //判断路由是否已经打开
      //已经打开的 ，将其置为active
      //未打开的，将其放入队列里
      let flag = false;
      for (let item of this.openTabs) {
        if (item.name === to.name) {
          this.$store.commit('set_active_index', to.path)
          flag = true;
          break;
        }
      }
      if (!flag) {
        this.$store.commit('add_tabs', {route: to.path, name: to.name});
        this.$store.commit('set_active_index', to.path);
      }
    }
  }
}
</script>

<style lang="less" scoped>
.el-container {
  height: 100%;
}

.el-main {
  padding: 0;
  background: #F4F8FB;
}

.content {
  padding: 31px 30px 0;
  box-sizing: border-box;
  height: calc(100% - 60px);
}
</style>
